import React from 'react';
import Popup from 'reactjs-popup';
import {Button} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import ReactJson from 'react-json-view';
export default function DeviceDetailPopup(props){
    return (
        <Popup modal trigger={<Button variant="info"><FontAwesomeIcon icon={faInfoCircle}/></Button>}>
                <div>
                <pre className="pre-scrollable">
                <ReactJson 
                src={props.deviceState} 
                indentWidth = {8}
                name = "shadow"
                />
                </pre>
                </div>
        </Popup>
    )    
}
